import React, { Component } from 'react';
import AlertModal from 'admin/components/shared/AlertModal';
import LoadingSpinner from 'admin/components/shared/LoadingSpinner';
import SystemNotification from 'admin/components/organisms/SystemNotification';
import { closeAlertModal } from 'admin/actions/alert-modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

export const AppContext = React.createContext();

class App extends Component {
  render() {
    return (
      <AppContext.Provider value={{ user: this.props.user }}>
        {this.props.children}
        <AlertModal {...this.props.alertModal} />
        <LoadingSpinner loading={this.props.loadingSpinner.isLoading} />
        <SystemNotification />
      </AppContext.Provider>
    );
  }
}

App.defaultProps = {
  alertModal: {
    isModalOpen: false,
  },
  loadingSpinner: {
    isLoading: false,
  },
};

const mapStateToProps = (state) => {
  return {
    alertModal: state.alertModal,
    loadingSpinner: state.loadingSpinner,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(App);
